import '../../../../legacy-library/webcomponents/svg-icon/svg-icon';
import '../../../elements/glide-element/glide-element';
import '../product-variant/product-variant';

import { TemplateElement, html, toString, i18n, defineElement } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import styles from './product-variant-slider.css';
import FrameSelectorEvent from '../../frame-selector/FrameSelectorEvent';
import ColorSelectorEvent from '../color-selector/ColorSelectorEvent';
import ProductCardEvents from '../product-card/ProductCardEvents';

export default class ProductVariantSlider extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [styles] });
    }

    properties() {
        return {
            variants: [],
            showSubline: true,
        };
    }

    watch() {
        return {
            variants: variants => {},
        };
    }

    events() {
        return {
            /*'glide-element': {
                [GlideElementEvents.GLIDE_RUN]: ev => {
                    this.currentProductIndex = ev.detail || 0;
                },
            },*/
            '[ref=arrowNext]': {
                click: () => this.$refs.slider.next(),
            },
            '[ref=arrowPrev]': {
                click: () => this.$refs.slider.prev(),
            },
        };
    }

    template() {
        if (!this.variants || this.variants.length === 0) return null;

        return html`
            <div class="relative">
                ${unsafeHTML(this.sliderTemplate())}
                ${this.variants?.length > 1
                    ? html`
                          <div class="arrow absolute left-0" ref="arrowPrev">
                              <svg-icon name="prev" class="w-4 h-4"></svg-icon>
                          </div>
                          <div class="arrow absolute right-0" ref="arrowNext">
                              <svg-icon name="next" class="w-4 h-4"></svg-icon>
                          </div>
                      `
                    : ''}
            </div>
        `;
    }

    sliderTemplate() {
        const options = {
            type: 'carousel',
            perView: 1,
            startAt: this.currentProductIndex,
            keyboard: false,
            swipeThreshold: 0,
            dragThreshold: 0,
        };

        return `
            <glide-element
                bullets="false"
                arrows="false"
                class="block"
                ref="slider"
                options='${toString(options)}'
            >
                    ${this.variants
                        .map(
                            variant => `
                                <product-variant variant='${toString(variant)}' class=""></product-variant>
                            `
                        )
                        .join('')}
                </glide-element>`;
    }
}

defineElement('product-variant-slider', ProductVariantSlider);
